<section>
  <mat-tab-group
    [selectedIndex]="data?.sentence?.label === 'Sentence Details' ? 1 : 0"
    class="source-details-tabs"
  >
    <mat-tab>
      <ng-template mat-tab-label>Verbatim Details</ng-template>
      <ng-template matTabContent>
        <app-verbatim-details
          [verbatim]="data?.verbatim?.verbatim"
          [verbatimId]="data?.verbatim?.verbatimId"
          [categoryNames]="data?.verbatim?.categoryNames"
        ></app-verbatim-details>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>{{ data?.sentence?.label }}</ng-template>
      <ng-template matTabContent>
        @if (data?.sentence?.sentences) {
          <app-verbatim-sentences
            [sentences]="data?.sentence?.sentences"
            [hashes]="data?.sentence?.hashes"
            [lookup]="data?.sentence?.lookup"
            [verbatimId]="data?.verbatim?.verbatimId"
          ></app-verbatim-sentences>
        }
      </ng-template>
    </mat-tab>
    @if (data?.chatAttributes) {
      <mat-tab>
        <ng-template mat-tab-label>Chat Attributes</ng-template>
        <ng-template matTabContent>
          <app-verbatim-chat-attributes
            [chatMsg]="data.chatAttributes?.chatMsg"
            [fieldGroups]="data.chatAttributes?.fieldGroups"
          ></app-verbatim-chat-attributes>
        </ng-template>
      </mat-tab>
    }
    <mat-tab>
      <ng-template mat-tab-label>Structured Data Details</ng-template>
      <ng-template matTabContent>
        @if (data?.structuredData?.structuredData?.length > 0) {
          <app-verbatim-structured-fields
            [structuredData]="data.structuredData?.structuredData"
            [fieldGroups]="data.structuredData?.fieldGroups"
          ></app-verbatim-structured-fields>
        }
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <div class="dialog-buttons-container add-top-margin justify-content-end">
    <button
      mat-stroked-button
      color="primary"
      #button
      (click)="dialogRef.close()"
      class="button"
    >
      <span class="dark-text">Close</span>
    </button>
  </div>
</section>
